var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('BaseCardContainer',{attrs:{"title":"Nouvel échange","noFooter":""}},[_c('EchangeForm',{attrs:{"id":"form","relation":_vm.relation,"contacts":_vm.prospect && _vm.prospect.CONTACTS},on:{"onSubmit":_vm.onSubmit,"onCancel":_vm.onCancel}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }